/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { OrgAdminGetUserDetailOptions, OrgAdminGetUserDetailStatus200, OrgAdminGetUserDetailStatus422 } from '../models/OrgAdminGetUserDetail'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { orgAdminGetUserDetail } from '../clients/axios/orgAdminGetUserDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const orgAdminGetUserDetailQueryKey = ({ path }: Omit<OrgAdminGetUserDetailOptions, 'headers'>) => [{ url: '/user/:user_id/detail', params: path }] as const

type OrgAdminGetUserDetailQueryKey = ReturnType<typeof orgAdminGetUserDetailQueryKey>

export function orgAdminGetUserDetailQueryOptions({ path }: OrgAdminGetUserDetailOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = orgAdminGetUserDetailQueryKey({ path })
  return queryOptions<OrgAdminGetUserDetailStatus200, ResponseErrorConfig<OrgAdminGetUserDetailStatus422>, OrgAdminGetUserDetailStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await orgAdminGetUserDetail({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get user detail, including courses.
 * This endpoint is intended for org admins to view details of users in their org.
 * @summary Get User Detail
 * {@link /user/:user_id/detail}
 */
export function useOrgAdminGetUserDetail<TData = OrgAdminGetUserDetailStatus200, TQueryData = OrgAdminGetUserDetailStatus200, TQueryKey extends QueryKey = OrgAdminGetUserDetailQueryKey>({ path }: { path: OrgAdminGetUserDetailOptions['path'] | (() => OrgAdminGetUserDetailOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<OrgAdminGetUserDetailStatus200, ResponseErrorConfig<OrgAdminGetUserDetailStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? orgAdminGetUserDetailQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...orgAdminGetUserDetailQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OrgAdminGetUserDetailStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
